<template>
  <div>
    <Navigation />
    <div class="grid__section">
    <section class="section__container top__container blog__details">
  

      <h1 class="title center__text">
        ENVOI SMS POUR LES CONCESSIONNAIRES AUTOMOBILES, GARAGISTES, LOUEURS
      </h1>
           <img class="card__image" src="/../images/car.png" alt="" />
      <h2>Partez à la conquête de nouveaux prospects.</h2>
      <p>
        Les marques automobiles sont engagées dans une course pour conquérir des parts de marché dans leur secteur.
        Pour atteindre leurs objectifs, la plupart d'entre elles investissent dans l'achat de bases de données
        qu'elles exploitent pour cibler et convaincre de nouveaux acheteurs.
      </p>
      <p>
        Leurs campagnes de SMS sont souvent accompagnées d'appels de prospection et de campagnes d'e-mails pour
        établir un premier contact. Ainsi, il leur est facile de suivre les statistiques de leurs efforts en 
        mettant à jour les fichiers clients, bien plus efficacement qu'avec une simple campagne de marketing direct.
      </p>
      <h2>Renforcez la fidélité de votre clientèle.</h2>
      <p>
        La digitalisation de la communication révolutionne les méthodes de prospection dans le secteur automobile. 
        Grâce à la réalité virtuelle, aux applications dédiées et aux réseaux sociaux, les consommateurs sont de
        plus en plus habitués à une relation interactive qui leur permet d'établir un lien fort avec les marques.
      </p>
      <p>
        Pour les constructeurs, l'enjeu est de maintenir un lien continu entre le premier signe d'intérêt pour la marque, 
        le premier contact, l'achat, l'utilisation, la maintenance et enfin le renouvellement du véhicule. À chaque étape,
        la communication par SMS agit comme un lien garantissant la proximité et la considération que la marque accorde à son client.
      </p>
      <p>
        Un exemple de cette évolution dans les comportements d'achat est la popularité croissante des sites de vente en ligne 
        d'automobiles, qui proposent des outils de personnalisation de plus en plus performants. Ces outils permettent de 
        proposer une multitude de configurations qui alimentent la planification de la production sans compromettre 
        l'optimisation des flux.
      </p>
      <p>
        Dans votre secteur d'activité, l'utilisation de SMS professionnels est essentielle pour fidéliser vos clients.
        Ce média est un moyen efficace de fournir des informations sur leur véhicule, les services complémentaires que
        vous pouvez leur offrir et les grandes opérations que vous mettez en place.
      </p>
      <h2>
        Avec Servicesms.sn, vous pouvez efficacement informer et sensibiliser vos clients et prospects sur les opérations suivantes :
      </h2>
      
        <li>Journées portes ouvertes <br /> </li>
         <li>Présentations sur les lieux de vente, tels que les grandes surfaces ou les parkings
        <br /> </li>
         <li>Opérations de déstockage de véhicules<br /> </li>
         <li>Promotions de nouveaux véhicules<br /> </li>
         <li>Rappels d'entretien<br /> </li>
         <li>Alertes de disponibilité de véhicules prêts<br /> </li>
         <li>Relances de paiement <br /> </li>
         <li>Envoi de devis pour confirmation </li>
         <li>Interventions post-diagnostic, etc. </li>
         <p>Nos services de SMS professionnels vous permettent d'atteindre efficacement votre audience
           et de communiquer de manière ciblée sur ces différentes opérations.</p>
      
      <h2>Exemples de SMS pour le secteur automobile :</h2>
      <div class="cards">
        <div class="card">
          <img class="card__image" src="/../images/location-auto-1.png" />
        </div>
        <div class="card">
          <img class="card__image" src="/../images/location-auto-2.png" />
        </div>
        <div class="card">
          <img class="card__image" src="/../images/location-auto-3.png" />
        </div>
      </div>
    
  
   
    </section>
 <SideNav/>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Navigation from "./Navigation";
import Footer from "./Footer";
import SideNav from "./SideNav";
export default {
  components: {
    Navigation,
    Footer,
    SideNav
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/base.scss";
</style>
